/* eslint-disable no-loop-func */
import { wallnameBySec } from "../redux/reducers/building_component/componentReducer";
import { params } from "../redux/reducers/reducer";
import { const_var } from "../redux/reducers/reducer";
import { findMaxLimitY } from "../helpers/building/building_config/componentConfig";
import { revertPosOfCmp } from "./Functions";
import { LimitValueOnWall } from "./GetCmpInfoOnWall";

export const wallNameArrForValid = [
    ['c_b_f_w', 'c_b_l_s_f_w', 'c_b_r_s_f_w', 'F_L_B_S_W', 'G_F_L_B_W'],
    ['c_b_b_w', 'c_b_l_s_b_w', 'c_b_r_s_b_w', 'B_L_B_S_W', 'G_B_L_B_W'],
    ['c_b_l_w', 'c_b_l_s_w', 'L_L_R_S_W', 'c_b_f_s_l_w', 'G_L_L_B_W'],
    ['c_b_r_w', 'c_b_r_s_w', 'R_L_L_S_W', 'c_b_f_s_r_w', 'G_R_L_B_W'],
    ['c_b_f_s_b_w'],
    ['c_b_f_s_w'],
    ['c_b_b_s_w'],
    ['c_b_l_s_r_w'],
    ['c_b_r_s_l_w'],
    ['F_L_R_W'],
    ['F_L_F_W', 'F_L_F_S_W'],
    ['F_L_L_W'],
    ['F_L_R_S_W'],
    ['F_L_L_S_W'],
    ['L_L_F_W'],
    ['L_L_L_W', 'L_L_L_S_W'],
    ['L_L_B_W'],
    ['L_L_F_S_W'],
    ['L_L_B_S_W'],
    ['R_L_F_W'],
    ['R_L_R_W', 'R_L_R_S_W'],
    ['R_L_B_W'],
    ['R_L_F_S_W'],
    ['R_L_B_S_W'],
    ['B_L_F_W'],
    ['B_L_S_W', 'B_L_F_S_W'],
    ['B_L_B_W'],
    ['B_L_L_S_W'],
    ['B_L_R_S_W'],
    ['G_F_L_F_W'],
    ['G_F_L_L_W', 'G_F_L_L_S_W'],
    ['G_F_L_R_W', 'G_F_L_R_S_W'],
    ['G_F_L_F_S_W'],
    ['G_F_L_B_S_W'],
    ['G_B_L_F_W'],
    ['G_B_L_L_W', 'G_B_L_L_S_W'],
    ['G_B_L_R_W', 'G_B_L_R_S_W'],
    ['G_B_L_F_S_W'],
    ['G_B_L_B_S_W'],
    ['G_L_L_F_W'],
    ['G_L_L_L_W', 'G_L_L_L_S_W'],
    ['G_L_L_R_W', 'G_L_L_R_S_W'],
    ['G_L_L_F_S_W'],
    ['G_L_L_B_S_W'],
    ['G_R_L_F_W'],
    ['G_R_L_L_W', 'G_R_L_L_S_W'],
    ['G_R_L_R_W', 'G_R_L_R_S_W'],
    ['G_R_L_F_S_W'],
    ['G_R_L_B_S_W'],
]

export const addValidation = ({ compType, width, height, wallName, parentkey, childkey, nestedkey, checkType, checkableDoorArr }) => {    
    // console.log('addValidation- input: ', { compType, width, height, wallName, parentkey, childkey, nestedkey, checkType, checkableDoorArr });
    
    let endClearance = 1;
    let sideClearance = 1;
    const component = const_var.newComponentArray[parentkey].find(item => item.type == childkey && item.alias_name == nestedkey);
    if (component) {
        const sizedComponent = component.sizes.find(item => item.fixed_sizes?.[0]?.width == width && item.fixed_sizes?.[0]?.height == height);
        endClearance = (sizedComponent != undefined && sizedComponent.end_clearance) ? sizedComponent.end_clearance : 1;
        sideClearance = (sizedComponent != undefined && sizedComponent.side_clearance) ? sizedComponent.side_clearance : 1;
    }

    const clearance = {endClearance, sideClearance};
    const isEndSide = const_var.entry_wall_location[wallName];

    const regularHeight = 0;
    const trimHeight = 0;

    let isAdd = false;
    let positionX = 0;
    let positionY = 0;

    let minLimitY = 0;
    let maxLimitY = 0;

    /********** y - limit **********/
    let topPos = LimitValueOnWall("valid", compType, wallName, width, height, positionY, false, clearance, isEndSide).limitY.max;
    let bottomPos = 
        (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout")
        ?
        0
        :
        (height/3) - 0.5 + const_var.componentDistance;

    minLimitY = (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout") ? bottomPos : const_var.componentDistance + height / 2;
    if((compType != "garage_door" && compType != "garage_door_frameout" && compType != "walkin" && compType != "walkin_frameout")) minLimitY = Number(minLimitY.toFixed(2))
    maxLimitY = topPos;
    /********** y - limit **********/

    if (clearance && (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout")) {
        if (isEndSide.includes('end') && clearance.endClearance) {
            topPos -= clearance.endClearance;
            endClearance = clearance.endClearance;
        } else {
            if ((params.m_s_n==3 || params.m_s_n==167)&& !isEndSide.includes('end') && compType === 'garage_door_frameout') {
                if (width >=13) {
                    topPos -= 2;
                }
            }else {
                 if (clearance.sideClearance) {
                    topPos -= clearance.sideClearance;

                    if ((const_var.editAPIDataByResponse.data?.main_created_at < '2025-08-27') && (compType === "walkin" || compType === "walkin_frameout")) {
                        topPos += clearance.sideClearance;
                    }
                 }else{
                     topPos -=1;
                 }
            }
        }
    }else{
        if(compType.includes('garage')) topPos -= 1;
    }
    
    /********** calculate position x, y **********/
    const count = Math.floor((topPos + height / 2 - bottomPos - 1.5) / 0.1);

    let minLimitX = 0;
    let maxLimitX = 0;

    const newArray = [...const_var.newDoorsArray];
    const targetWallNameArr = wallNameArrForValid.find(subArray => subArray.includes(wallName));
    const doorsArray = checkType === 'update_check' ? [...checkableDoorArr] : [...const_var.newDoorsArray];
    
    revertPosOfCmp(doorsArray, wallName)

    for (let i = 0; i <= count; i++) {
        /********** calculate position y **********/
        if (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout") {
            positionY = height / 2;
        } else {
            if (height > 4) {
                positionY = height / 2 + const_var.componentDistance + i * 1 / 12
            } else {
                positionY = bottomPos + 1.5 + i * 1 / 12;
            }
        }
        /********** calculate position y **********/

        /********** x - limit **********/
        let leftPos = LimitValueOnWall("valid", compType, wallName, width, height, positionY, false, clearance, isEndSide).limitX.min;
        let rightPos = LimitValueOnWall("valid", compType, wallName, width, height, positionY, false, clearance, isEndSide).limitX.max;

        minLimitX = leftPos;
        maxLimitX = rightPos;
        /********** x - limit **********/

        // leftPos = Math.sign(leftPos) * Math.ceil(Math.abs(leftPos) * Math.pow(10, 5)) / Math.pow(10, 5);
        // rightPos = Math.sign(rightPos) * Math.ceil(Math.abs(rightPos) * Math.pow(10, 5)) / Math.pow(10, 5);
        
        /********** calculate position x **********/
        const sideArray = doorsArray.filter((item) => 
            targetWallNameArr.includes(item.userData.wallName) && 
            item.positionX + item.width > leftPos && item.positionX - item.width < rightPos && 
            item.positionY - item.height / 2 < positionY + height / 2 + const_var.componentDistance && 
            item.positionY + item.height / 2 > positionY - height / 2 - const_var.componentDistance
        ).sort((a, b) => (a.positionX - a.width / 2) - (b.positionX - b.width / 2));

        if (sideArray.length === 0) {
            let isHeight = 1;
            if (height > params.p_h + regularHeight - trimHeight - endClearance) {
                isHeight = 0;
            }
            if (Math.abs(rightPos - leftPos) >= width + (const_var.componentDistance * 2 * isHeight)) {
                if (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout") {
                    if (topPos - bottomPos >= height) {
                        isAdd = true;
                    }
                } else {
                    if (topPos - bottomPos >= 0) {
                        isAdd = true;
                    }
                }

                if (isAdd) {
                    positionX = leftPos + (rightPos - leftPos) / 2;
                }
            }
        } else {
            if (((compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout") && (topPos - bottomPos < height)) || 
                ((compType === "window" || compType === "window_frameout") && (topPos - bottomPos < 0))
            ) {
                isAdd = false;
            } else {
                let prevPos = leftPos;
                let round = 0;
                for (let item of sideArray) {
                    if (round === 0 && (item.positionX - item.width / 2) > rightPos) {
                        if(rightPos - prevPos >= (width + const_var.componentDistance * 2)) {
                            positionX = prevPos + (rightPos - prevPos) / 2;
                            isAdd = true;
                            break;
                        } else {
                            break;
                        }
                    } else {
                        if((item.positionX - item.width / 2) - prevPos >= (width + const_var.componentDistance * 2)) {
                            const tempPositionX = prevPos + ((item.positionX - item.width / 2) - prevPos) / 2;
                            const overlapVerticalCmp = sideArray.find(s => (
                                s.positionX - s.width / 2 < tempPositionX + width / 2 + const_var.componentDistance && 
                                s.positionX + s.width / 2 > tempPositionX - width / 2 - const_var.componentDistance &&
                                s.positionY - s.height / 2 < positionY + height / 2 + const_var.componentDistance && 
                                s.positionY + s.height / 2 > positionY - height / 2 - const_var.componentDistance  
                            ))

                            if (overlapVerticalCmp) {
                                prevPos = item.positionX + item.width / 2;
                            } else {

                                if (compType === "window" || compType === "window_frameout") {
                                    if (tempPositionX >= (leftPos + width/2 + const_var.componentDistance) && tempPositionX <= (rightPos - width/2 - const_var.componentDistance)) {
                                        positionX = tempPositionX;
                                        isAdd = true;
                                        break;
                                    }
                                } else {
                                    positionX = tempPositionX;
                                    isAdd = true;
                                    break;
                                }
                            }
                        } else {
                            prevPos = item.positionX + item.width / 2 > leftPos ? item.positionX + item.width / 2: leftPos;
                        }
                    }
                    round++;
                }
            
                if (!isAdd) {
                    if (prevPos > leftPos) {
                        const maxPosValueOfEndCmp = sideArray.reduce((max, obj) => obj.positionX + obj.width / 2 > max ? obj.positionX + obj.width / 2 : max, sideArray[0].positionX + sideArray[0].width / 2);
                        if (prevPos < maxPosValueOfEndCmp) prevPos = maxPosValueOfEndCmp;

                        if(rightPos - prevPos >= (width + const_var.componentDistance * 2)) {
                            positionX = prevPos + (rightPos - prevPos) / 2;
                            isAdd = true;
                        }
                    } else {
                        if(rightPos - leftPos >= (width + const_var.componentDistance * 2)) {
                            positionX = leftPos + (rightPos - leftPos) / 2;
                            isAdd = true;
                        }
                    }
                }
            }
        }
        
        /********** calculate position x **********/
        if (!isAdd && (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout")) {
            let currentDoorsArr = const_var.newDoorsArray;
            if (checkType === 'update_check') currentDoorsArr = checkableDoorArr;
            
            if (topPos - bottomPos >= height) {
                let isUpdate = true;
                const calculateArray = currentDoorsArr.filter((item) => 
                        targetWallNameArr.includes(item.userData.wallName) && 
                        item.positionY - item.height / 2 < height + const_var.componentDistance
                    ).sort((a, b) => a.positionX - b.positionX)
                let distance = 0;
                for(let i = 0; i < calculateArray.length; i++) {
                    distance = distance + calculateArray[i].width 
                }
    
                if (rightPos - leftPos >= distance + width + (calculateArray.length + 2) * const_var.componentDistance) {
                    for(let i = 0; i < calculateArray.length; i++) {
                        if ((calculateArray[i].userData.compType !== "garage_door" && calculateArray[i].userData.compType !== "garage_door_frameout" && calculateArray[i].userData.compType !== "walkin" && calculateArray[i].userData.compType !== "walkin_frameout") && calculateArray[i].positionY + calculateArray[i].height / 2 > height) {
                            isUpdate = false;
                            break;
                        }
                    }
                } else {
                    isUpdate = false;
                }
    
                if (isUpdate) {
                    let updatePosCheck = true;
                    let lastDistance = 0;
                    for(let i = 0; i < calculateArray.length; i++) {
                        const index = newArray.findIndex(item => item.uniqueId === calculateArray[i].uniqueId);
                        if (index !== -1) {
                            const newPosX = leftPos + lastDistance + const_var.componentDistance + calculateArray[i].width / 2;
                            const overlapVerticalCmp = const_var.newDoorsArray.find(s => (
                                targetWallNameArr.includes(s.userData.wallName) && 
                                (s.userData.compType === 'window' || s.userData.compType === "window_frameout") &&
                                s.positionX - s.width / 2 < newPosX + calculateArray[i].width / 2 + const_var.componentDistance && 
                                s.positionX + s.width / 2 > newPosX - calculateArray[i].width / 2 - const_var.componentDistance &&
                                s.positionY - s.height / 2 < calculateArray[i].height + const_var.componentDistance && 
                                s.positionY + s.height / 2 > calculateArray[i].height - const_var.componentDistance  
                            ))
                            if (overlapVerticalCmp) {
                                updatePosCheck = false;
                                break;
                            }

                            const updatedPos = leftPos + lastDistance + const_var.componentDistance + calculateArray[i].width / 2;

                            if(newArray[index].minLimitX > updatedPos || updatedPos > newArray[index].maxLimitX) {
                                updatePosCheck = false;
                                break;
                            }
                            newArray[index].positionX = updatedPos;
                            
                            lastDistance = lastDistance + const_var.componentDistance + calculateArray[i].width;
                        }
                    }
    
                    if (updatePosCheck) {
                        isAdd = true;
                        positionX = leftPos + lastDistance + const_var.componentDistance + width / 2;

                        newArray.forEach((edoor) => {
                            const_var.entry_points.filter(e => e.uniqueId == edoor.uniqueId).forEach(door => {
                                door.entry_position.positionX = edoor.positionX;
                            })
                        })
                    } else {
                        const_var.newDoorsArray = newArray;
                        const_var.entry_points.forEach((edoor) => {
                            const_var.newDoorsArray.filter(e => e.uniqueId == edoor.uniqueId).forEach(door => {
                                door.positionX = edoor.entry_position.positionX;
                            })
                        })
                    }
                }
            }
        }

        if (isAdd || compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout") {
            minLimitX = (leftPos + width / 2 + const_var.componentDistance);
            maxLimitX = (rightPos - width / 2 - const_var.componentDistance);            
            break;
        }
    }
    const buildingType = wallnameBySec[wallName];
    let maxLimitObjY = findMaxLimitY(buildingType, wallName, height, width, const_var.componentDistance,positionX, topPos)
    if (compType === "window" || compType === "window_frameout") {
        if (positionX < minLimitX || positionX > maxLimitX || positionY < bottomPos || positionY > topPos || positionY > maxLimitObjY?.maxLimit) {
            isAdd = false;
        }
    }
    /********** calculate position x, y **********/
    
    revertPosOfCmp(doorsArray, wallName)

    return {
        isAdd, positionX, positionY, minLimitX, maxLimitX, newArray, minLimitY, maxLimitY
    }
}

export const editValidation = ({ compType, compName, width, height, wallName, parentkey, childkey, nestedkey, positionX, positionY, sideArray }) => {
    // console.log('editValidation- input: ', { compType, compName, width, height, wallName, parentkey, childkey, nestedkey, positionX, positionY, sideArray });

    let endClearance = 1;
    let sideClearance = 1;
    const component = const_var.newComponentArray[parentkey].find(item => item.type == childkey && item.alias_name == nestedkey);
    if (component) {
        const sizedComponent = component.sizes.find(item => item.fixed_sizes?.[0]?.width == width && item.fixed_sizes?.[0]?.height == height);
        endClearance = (sizedComponent != undefined && sizedComponent.end_clearance) ? sizedComponent.end_clearance : 1;
        sideClearance = (sizedComponent != undefined && sizedComponent.side_clearance) ? sizedComponent.side_clearance : 1;
    }
    const clearance = {endClearance, sideClearance};
    const isEndSide = const_var.entry_wall_location[wallName];

    let isEdit = false;
    let isChangePos = false;

    /********** y - limit **********/
    let topPos = LimitValueOnWall("valid", compType, wallName, width, height, positionY, false, clearance, isEndSide).limitY.max;
    let bottomPos = LimitValueOnWall("valid", compType, wallName, width, height, positionY, false, clearance, isEndSide).limitY.min;
    /********** y - limit **********/



    if (clearance && (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout")) {
        if (isEndSide.includes('end') && clearance.endClearance) {
            topPos -= clearance.endClearance;
            endClearance = clearance.endClearance;
        } else {
            if ((params.m_s_n==3 || params.m_s_n==167)&& !isEndSide.includes('end') && compType === 'garage_door_frameout') {
                if (width >=13) {
                    topPos -= 2;
                }
            }else {
                 if (clearance.sideClearance) {
                    topPos -= clearance.sideClearance;

                    if ((const_var.editAPIDataByResponse.data?.main_created_at < '2025-08-27') && (compType === "walkin" || compType === "walkin_frameout")) {
                        topPos += clearance.sideClearance;
                    }
                 }else{
                     topPos -=1;
                 }
            }
        }
    }else{
        if(compType.includes('garage')) topPos -= 1;
    }

    /********** x - limit **********/
    if (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout") {
        positionY = height / 2;
    }

    let leftPos = LimitValueOnWall("valid", compType, wallName, width, height, positionY, false, clearance, isEndSide).limitX.min;
    let rightPos = LimitValueOnWall("valid", compType, wallName, width, height, positionY, false, clearance, isEndSide).limitX.max;
    /********** x - limit **********/
    const doorsArray = [...sideArray];
    revertPosOfCmp(doorsArray, wallName)

    const validationArray = doorsArray.filter((item) => 
        (item.positionX + item.width / 2 > positionX - width / 2 - const_var.componentDistance && 
            item.positionX - item.width / 2 < positionX + width / 2 + const_var.componentDistance) && 
        (item.positionY - item.height / 2 < positionY + height / 2 + const_var.componentDistance && 
            item.positionY + item.height / 2 > positionY - height / 2 - const_var.componentDistance
        )
    );

    if (validationArray.length === 0) {
        if (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout") {
            if ((positionX - width / 2 - const_var.componentDistance >= leftPos && positionX + width / 2 + const_var.componentDistance <= rightPos) && (height <= topPos)) {
                isEdit = true;
            }
        } else {
            if ((positionX - width / 2 - const_var.componentDistance >= leftPos && positionX + width / 2 + const_var.componentDistance <= rightPos) && (positionY + height / 2 < topPos && positionY - height / 2 > bottomPos)) {
                isEdit = true;
            }
        }
    }

    const minLimitX = leftPos;
    const maxLimitX = rightPos;

    revertPosOfCmp(doorsArray, wallName)

    // Verify using additional functions when there is no space nearby.
    if (!isEdit) {
        const isAddCheck = addValidation({ compType, compName, width, height, wallName, parentkey, childkey, nestedkey, checkType: 'update_check', checkableDoorArr: sideArray }).isAdd;
        if (isAddCheck) {
            isEdit = true;
            isChangePos = true;
        }     
    }
 
    
    return {
        isEdit, isChangePos, minLimitX, maxLimitX
    }
}

export const cupolaValidation = (length, checkType, filterCupolaArr) => {
    const offset = 0.5
    const sortByIdArray = const_var.cupolas.sort((a, b) => a.uniqueId - b.uniqueId);
    const cupolaCount = sortByIdArray.length > 0 ? const_var.cupolas[const_var.cupolas.length - 1].uniqueId + 1 : 0;

    let isAdd = false;
    let positionZ = 0;

    let prevPosZ = -params.p_d / 2;
    let nextPosZ = params.p_d / 2;

    const minLimitZ = -params.p_d / 2;
    const maxLimitZ = params.p_d / 2;
    
    
    const sortArray = const_var.cupolas.sort((a, b) => a.positionZ - b.positionZ);
    let newArray = [...const_var.cupolas];
    if (checkType === 'update_check') newArray = [...filterCupolaArr];

    if (sortArray.length === 0) {
        if (params.p_d > length + 2 * const_var.componentDistance + offset) {
            isAdd = true;
            positionZ = 0;
        }
    } else {
        for (let item of sortArray) {
            if (Math.abs(item.positionZ - prevPosZ) >= item.length / 2 + 2 * const_var.componentDistance + offset + length) {                
                positionZ = prevPosZ + (item.positionZ - item.length / 2 - prevPosZ) / 2;
                isAdd = true;
                break;
            } else {
                prevPosZ = item.positionZ + item.length / 2;
            }
        }

        if (!isAdd) {
            if (Math.abs(nextPosZ - prevPosZ) >= 2 * const_var.componentDistance + offset + length) {
                positionZ = prevPosZ + (nextPosZ - prevPosZ) / 2;
                isAdd = true;
            } else {
                isAdd = false;
            }
        }

        if(!isAdd) {
            let isUpdate = true;

            const calculateArray = newArray.sort((a, b) => a.positionZ - b.positionZ);

            let distance = 0;
            for(let i = 0; i < calculateArray.length; i++) {
                distance = distance + calculateArray[i].length
            }
            
            if (params.p_d < distance + length + (calculateArray.length + 2) * const_var.componentDistance + offset) {
                isUpdate = false;
            }
    
            if(isUpdate) {
                let lastDistance = 0;
                for(let i = 0; i < calculateArray.length; i++) {
                    const index = newArray.findIndex(item => item.uniqueId === calculateArray[i].uniqueId);
                    if(index !== -1) {
                        newArray[index].positionZ = -params.p_d / 2 + lastDistance + const_var.componentDistance + offset + calculateArray[i].length / 2;
                        lastDistance = lastDistance + const_var.componentDistance + offset + calculateArray[i].length
                    }
                }

                isAdd = true;
                positionZ = -params.p_d / 2 + lastDistance + const_var.componentDistance + offset + length / 2
            }
        }
        if(positionZ > maxLimitZ || positionZ < minLimitZ) isAdd = false;
    }

    return {
        isAdd, positionZ, minLimitZ, maxLimitZ, cupolaCount, newArray
    }
}

export const cupolaEditValidation = (cupolaId, newLength, filterCupolaArr = [], currentPos) => {
    const offset = 0.5

    let isEdit = false;
    let isChangePos = false;
    const minLimitZ = -params.p_d / 2;
    const maxLimitZ = params.p_d / 2;

    const validationArray = filterCupolaArr.filter((item) => (
        item.positionZ + item.length / 2 > currentPos - newLength / 2 - const_var.componentDistance + offset && 
        item.positionZ - item.length / 2 < currentPos + newLength / 2 + const_var.componentDistance + offset
        )
    );

    if (validationArray.length === 0) {
        if (currentPos - newLength / 2 - const_var.componentDistance + offset >= minLimitZ && currentPos + newLength / 2 + const_var.componentDistance + offset <= maxLimitZ) {
            isEdit = true;
        }
    }

    if (!isEdit) {
        const isAddCheck = cupolaValidation(newLength, 'update_check', filterCupolaArr).isAdd
        if (isAddCheck) {
            isEdit = true;
            isChangePos = true;
        }
    }

    return { isEdit, isChangePos }
}

export const getIsEditableCmpOnWall = (wallName, campAngle) => {
    let isEditable = false;
    if (campAngle === 0) {
        if (wallName === 'c_b_f_w' || wallName === 'c_b_f_s_w' || wallName === 'F_L_F_W' || wallName === 'R_L_F_W' || wallName === 'L_L_F_W' || wallName === 'c_b_l_s_f_w' || wallName === 'c_b_r_s_f_w' || wallName === 'F_L_F_S_W' || wallName === 'R_L_F_S_W' || wallName === 'L_L_F_S_W' || 
            wallName === 'G_F_L_F_W' || wallName === 'G_F_L_F_S_W' || wallName === 'G_B_L_B_W' || wallName === 'G_B_L_B_S_W' || wallName === 'G_L_L_R_W' || wallName === 'G_L_L_R_S_W' || wallName === 'G_R_L_L_W' || wallName === 'G_R_L_L_S_W'
        ) {
            isEditable = true;
        }
    } else if (campAngle > 0 && campAngle < Math.PI / 2) {
        if (wallName === 'c_b_f_w' || wallName === 'c_b_f_s_w' || wallName === 'F_L_F_W' || wallName === 'R_L_F_W' || wallName === 'L_L_F_W' || wallName === 'c_b_l_s_f_w' || wallName === 'c_b_r_s_f_w' || wallName === 'F_L_F_S_W' || wallName === 'R_L_F_S_W' || wallName === 'L_L_F_S_W' ||
            wallName === 'c_b_r_w' || wallName === 'R_L_R_W' || wallName === 'F_L_R_W' || wallName === 'B_L_F_W' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_w' || wallName === 'F_L_R_S_W' || wallName === 'B_L_L_S_W' || wallName === 'R_L_R_S_W' || wallName === 'L_L_R_S_W' || 
            wallName === 'G_F_L_F_W' || wallName === 'G_F_L_F_S_W' || wallName === 'G_F_L_R_W' || wallName === 'G_F_L_R_S_W' || wallName === 'G_B_L_B_W' || wallName === 'G_B_L_B_S_W' || wallName === 'G_B_L_L_W' || wallName === 'G_B_L_L_S_W' ||
            wallName === 'G_L_L_B_W' || wallName === 'G_L_L_B_S_W' || wallName === 'G_L_L_R_W' || wallName === 'G_L_L_R_S_W' || wallName === 'G_R_L_F_W' || wallName === 'G_R_L_F_S_W' || wallName === 'G_R_L_L_W' || wallName === 'G_R_L_L_S_W'
        ) {
            isEditable = true;
        }
    } else if (campAngle === Math.PI / 2) {
        if (wallName === 'c_b_r_w' || wallName === 'R_L_R_W' || wallName === 'F_L_R_W' || wallName === 'B_L_F_W' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_w' || wallName === 'F_L_R_S_W' || wallName === 'B_L_L_S_W' || wallName === 'R_L_R_S_W' || wallName === 'L_L_R_S_W' || 
            wallName === 'G_F_L_R_W' || wallName === 'G_F_L_R_S_W' || wallName === 'G_B_L_L_W' || wallName === 'G_B_L_L_S_W' || wallName === 'G_L_L_B_W' || wallName === 'G_L_L_B_S_W' || wallName === 'G_R_L_F_W' || wallName === 'G_R_L_F_S_W'
        ) {
            isEditable = true;
        }
    } else if (campAngle > Math.PI / 2 && campAngle < Math.PI) {
        if (wallName === 'c_b_r_w' || wallName === 'R_L_R_W' || wallName === 'F_L_R_W' || wallName === 'B_L_F_W' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_w' || wallName === 'F_L_R_S_W' || wallName === 'B_L_L_S_W' || wallName === 'R_L_R_S_W' || wallName === 'R_L_B_S_W' || wallName === 'L_L_R_S_W' ||
            wallName === 'c_b_b_w' || wallName === 'c_b_b_s_w' || wallName === 'B_L_S_W' || wallName === 'R_L_B_W' || wallName === 'L_L_B_W' || wallName === 'c_b_l_s_b_w' || wallName === 'c_b_r_s_b_w' || wallName === 'B_L_F_S_W' ||
            wallName === 'G_F_L_R_W' || wallName === 'G_F_L_R_S_W' || wallName === 'G_F_L_B_W' || wallName === 'G_F_L_B_S_W' || wallName === 'G_B_L_F_W' || wallName === 'G_B_L_F_S_W' || wallName === 'G_B_L_L_W' || wallName === 'G_B_L_L_S_W' ||
            wallName === 'G_L_L_B_W' || wallName === 'G_L_L_B_S_W' || wallName === 'G_L_L_L_W' || wallName === 'G_L_L_L_S_W' || wallName === 'G_R_L_F_W' || wallName === 'G_R_L_F_S_W' || wallName === 'G_R_L_R_W' || wallName === 'G_R_L_R_S_W'
        ) {
            isEditable = true;
        }
    } else if (campAngle === Math.PI) {
        if (wallName === 'c_b_b_w'  || wallName === 'c_b_b_s_w' || wallName === 'B_L_S_W' || wallName === 'R_L_B_W' || wallName === 'R_L_B_S_W' || wallName === 'L_L_B_W' || wallName === 'L_L_B_S_W' || wallName === 'c_b_l_s_b_w' || wallName === 'c_b_r_s_b_w' || wallName === 'B_L_F_S_W' ||
            wallName === 'G_F_L_B_W' || wallName === 'G_F_L_B_S_W' || wallName === 'G_B_L_F_W' || wallName === 'G_B_L_F_S_W' || wallName === 'G_L_L_L_W' || wallName === 'G_L_L_L_S_W' || wallName === 'G_R_L_R_W' || wallName === 'G_R_L_R_S_W'
        ) {
            isEditable = true;
        }
    } else if (campAngle < 0 && campAngle > -Math.PI / 2) {
        if (wallName === 'c_b_f_w' || wallName === 'c_b_f_s_w' || wallName === 'F_L_F_W' || wallName === 'R_L_F_W' || wallName === 'L_L_F_W' || wallName === 'c_b_l_s_f_w' || wallName === 'c_b_r_s_f_w' || wallName === 'F_L_F_S_W' || wallName === 'R_L_F_S_W' || wallName === 'L_L_F_S_W' ||
            wallName === 'c_b_l_w' || wallName === 'L_L_L_W' || wallName === 'F_L_L_W' || wallName === 'F_L_L_S_W' || wallName === 'B_L_B_W' || wallName === 'c_b_r_s_l_w' || wallName === 'c_b_l_s_w' || wallName === 'R_L_L_S_W' || wallName === 'L_L_L_S_W' ||
            wallName === 'G_F_L_F_W' || wallName === 'G_F_L_F_S_W' || wallName === 'G_F_L_L_W' || wallName === 'G_F_L_L_S_W' || wallName === 'G_B_L_B_W' || wallName === 'G_B_L_B_S_W' || wallName === 'G_B_L_R_W' || wallName === 'G_B_L_R_S_W' ||
            wallName === 'G_L_L_F_W' || wallName === 'G_L_L_F_S_W' || wallName === 'G_L_L_R_W' || wallName === 'G_L_L_R_S_W' || wallName === 'G_R_L_B_W' || wallName === 'G_R_L_B_S_W' || wallName === 'G_R_L_L_W' || wallName === 'G_R_L_L_S_W'
        ) {
            isEditable = true;
        }
    } else if (campAngle === -Math.PI / 2) {
        if (wallName === 'c_b_l_w' || wallName === 'L_L_L_W' || wallName === 'F_L_L_W' || wallName === 'F_L_L_S_W' || wallName === 'B_L_B_W' || wallName === 'B_L_R_S_W' || wallName === 'c_b_r_s_l_w' || wallName === 'c_b_l_s_w' || wallName === 'R_L_L_S_W' || wallName === 'L_L_L_S_W' ||
            wallName === 'G_F_L_L_W' || wallName === 'G_F_L_L_S_W' || wallName === 'G_B_L_R_W' || wallName === 'G_B_L_R_S_W' || wallName === 'G_L_L_F_W' || wallName === 'G_L_L_F_S_W' || wallName === 'G_R_L_B_W' || wallName === 'G_R_L_B_S_W'
        ) {
            isEditable = true;
        }
    } else if (campAngle < -Math.PI / 2 && -Math.PI / 2 > -Math.PI) {
        if (wallName === 'c_b_l_w' || wallName === 'L_L_L_W' || wallName === 'L_L_B_S_W' || wallName === 'F_L_L_W' || wallName === 'B_L_B_W' || wallName === 'c_b_r_s_l_w' || wallName === 'c_b_l_s_w' || wallName === 'R_L_L_S_W' || wallName === 'L_L_L_S_W' ||
            wallName === 'c_b_b_w'  || wallName === 'c_b_b_s_w' || wallName === 'B_L_S_W' || wallName === 'R_L_B_W' || wallName === 'L_L_B_W' || wallName === 'c_b_l_s_b_w' || wallName === 'c_b_r_s_b_w' || wallName === 'B_L_F_S_W' || wallName === 'B_L_R_S_W' ||
            wallName === 'G_F_L_L_W' || wallName === 'G_F_L_L_S_W' || wallName === 'G_F_L_B_W' || wallName === 'G_F_L_B_S_W' || wallName === 'G_B_L_F_W' || wallName === 'G_B_L_F_S_W' || wallName === 'G_B_L_R_W' || wallName === 'G_B_L_R_S_W' ||
            wallName === 'G_L_L_F_W' || wallName === 'G_L_L_F_S_W' || wallName === 'G_L_L_L_W' || wallName === 'G_L_L_L_S_W' || wallName === 'G_R_L_B_W' || wallName === 'G_R_L_B_S_W' || wallName === 'G_R_L_R_W' || wallName === 'G_R_L_R_S_W'
        ) {
            isEditable = true;
        }
    }

    return isEditable;
}